import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AccessorialActionItemContainerComponent,
  ActionItemsContainerComponent,
  CounterOfferActionItemContainerComponent,
  LoadDetailContainerComponent,
} from '../shared/components';
import { AppActionGuard } from '../shared/guards';
import { RouteType } from '../shared/models';
import { SecurityAppActionType } from '../shared/models/security-app-action-type';
import {
  BookedContainerComponent,
  DeliveredContainerComponent,
  LoadBoardComponent,
  LoadStatusContainerComponent,
  SearchContainerComponent,
} from './components';
import { AuthGuard } from '../core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'loads',
    component: LoadBoardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'search',
        component: SearchContainerComponent,
        children: [{ path: 'detail/:id', component: LoadDetailContainerComponent, data: { sidebar: true } }],
        canActivate: [AppActionGuard],
        data: { roles: [SecurityAppActionType.CarrierMarketPlaceView], routeType: RouteType.Carrier },
      },
      {
        path: 'booked',
        component: BookedContainerComponent,
        children: [{ path: 'detail/:id', component: LoadDetailContainerComponent, data: { sidebar: true, captureReasonOnDelete: true } }],
        canActivate: [AppActionGuard],
        data: { roles: [SecurityAppActionType.CarrierMyLoadsView], routeType: RouteType.Carrier },
      },
      {
        path: 'delivered',
        component: DeliveredContainerComponent,
        children: [{ path: 'detail/:id', component: LoadDetailContainerComponent, data: { sidebar: true, captureReasonOnDelete: true } }],
        canActivate: [AppActionGuard],
        data: { roles: [SecurityAppActionType.CarrierViewDelivered], routeType: RouteType.Carrier },
      },
      {
        path: 'action-items',
        component: ActionItemsContainerComponent,
        children: [
          {
            path: '',
            redirectTo: 'counter-offers',
            pathMatch: 'full',
          },
          {
            path: 'accessorials',
            component: AccessorialActionItemContainerComponent,
            children: [{ path: 'detail/:id', component: LoadDetailContainerComponent, data: { sidebar: true, readOnly: true } }],
          },
          {
            path: 'counter-offers',
            component: CounterOfferActionItemContainerComponent,
            children: [{ path: 'detail/:id', component: LoadDetailContainerComponent, data: { sidebar: true, readOnly: true } }],
          },
          {
            path: 'counter-offers/:id',
            component: CounterOfferActionItemContainerComponent,
          },
        ],
      },
      {
        path: 'detail/:id',
        component: LoadDetailContainerComponent,
        canActivate: [AppActionGuard],
        data: { sidebar: false, roles: [SecurityAppActionType.ViewDetail] },
      },
      {
        path: 'status/:id',
        canActivate: [AppActionGuard],
        component: LoadStatusContainerComponent,
        data: { roles: [SecurityAppActionType.CarrierViewStatus], routeType: RouteType.Carrier },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoadBoardRoutingModule {}
